
export enum DocumentConversionType {
   SDFT_TO_PDF="sfdt-to-pdf",
   WORD_TO_SDFT="word-to-sfdt"
}